export default class CollapseVoiceAICallTranscript {
  constructor(context) {
    this.context = context;
  }

  run({ voiceAICallItemId, isTranscriptCollapsed }) {
    const voiceAICallItem = this.context.stores.conversationHistory.findBy({ id: voiceAICallItemId });
    if (!voiceAICallItem) {
      return;
    }

    voiceAICallItem.content.setTranscriptCollapsed(isTranscriptCollapsed);
    voiceAICallItem.incrementVersion();

    this.context.stores.conversationHistory.addOrReplace(voiceAICallItem);
  }
}
